import axiosIns from '@/utils/axios'

// 跳转微信公众号授权
export function wxAuthorize(state){

  window.location.href = axiosIns.defaults.baseURL + '/api/weixin/authorize?state=' + state
}

// 获取签名
export function wxGetSignature (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `api/weixin/getSignature`,
    method: 'get',
    params: params
  })
}

// 微信检测用户
export function wxCheckUser (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `api/weixin/checkUser`,
    method: 'get',
    params: params
  })
}

// 关联用户
export function userRelation (params) {
  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `api/user/relation`,
    method: 'post',
    params: params
  })
}

// 获取小程序unionid miniopenid
export function wxCheckMiniUser (params) {
  return axiosIns({
    url: 'api/weixin/checkMiniUser',
    method: 'get',
    params
  })
}

// 微信用户注册
export function wxUserRegister (openid, miniOpenid, unionid) {

  let params = {
    openid: openid,
    miniOpenid: miniOpenid,
    unionid: unionid
  }

  // axiosIns.defaults.owner = '08'
  return axiosIns({
    url: `api/user/wxRegister`,
    method: 'post',
    params: params
  })
}

// 获取h5授权地址
export function getH5AuthorizationUrl (callBackUrl) {
  return axiosIns({
    url: `api/weixin/getH5AuthorizationUrl?callBackUrl=${callBackUrl}`,
    method: 'get',
    })
}
//查询授权结果
export function getUserAuthorization(retCode,qrcode,userId){
  return axiosIns({
    url: `api/weixin/getUserAuthorization?retCode=${retCode}&qrcode=${qrcode}&userId=${userId}`,
    method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/wx.js